<script>
export default {
  name: 'MallTransitionExpand',

  functional: true,

  render(createElement, context) {
    const data = {
      props: {
        name: 'mall-expand'
      },

      on: {
        afterEnter(element) {
          element.style.height = `auto`;
        },

        enter(element) {
          const { width } = getComputedStyle(element);

          element.style.width = width;
          element.style.position = `absolute`;
          element.style.visibility = `hidden`;
          element.style.height = `auto`;

          const { height } = getComputedStyle(element);

          element.style.width = null;
          element.style.position = null;
          element.style.visibility = null;
          element.style.height = 0;

          // 强制重绘以确保正确触发动画。
          getComputedStyle(element).height;

          requestAnimationFrame(() => {
            element.style.height = height;
          });
        },

        leave(element) {
          const { height } = getComputedStyle(element);

          element.style.height = height;

          // 强制重绘以确保正确触发动画。
          getComputedStyle(element).height;

          requestAnimationFrame(() => {
            element.style.height = 0;
          });
        }
      }
    };

    return createElement(`transition`, data, context.children);
  }
};
</script>

<style lang="scss" scoped>
* {
  transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000px;
  will-change: height;
}
</style>

<style lang="scss">
.mall-expand-enter-active,
.mall-expand-leave-active {
  overflow: hidden;
  opacity: 1;
  transition: height .1s ease-in-out, opacity .5s;
}

.mall-expand-enter,
.mall-expand-leave-to {
  height: 0;
  opacity: 0;
}
</style>
